import { render, staticRenderFns } from "./standardModel.vue?vue&type=template&id=6502ddd6"
import script from "./standardModel.vue?vue&type=script&lang=js"
export * from "./standardModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports